// BRACKET EVENT IDS
export const playoffEventIdsDev = {
  //QUARTERS
  q1: 285,
  // q2: 224,
  q3: 286,
  //SEMIS
  s1: 287,
  s2: 288,
  //CHAMP
  c: 289,
}

// BRACKET EVENT IDS
export const playoffEventIdsProd = {
  //QUARTERS
  q1: 286,
  // q2: 224,
  q3: 285,
  //SEMIS
  s1: 294,
  s2: 295,
  //CHAMP
  c: 289,
}

export const playoffEventIds =
  process.env.NODE_ENV === 'development' ? playoffEventIdsDev : playoffEventIdsProd
